import React from "react";
export var Thumbnail = React.memo(function Thumbnail(props) {
    var id = props.id, stepIndex = props.stepIndex, patterns = props.patterns, category = props.category, plusStep = props.plusStep, updateScore = props.updateScore;
    var BASEURL = "";
    function handleClick() {
        var target = patterns.find(function (item) { return item.category === category; });
        plusStep(stepIndex);
        updateScore(target, 1);
    }
    return (<button className="p-likesystem__body__thumbnail" onClick={function () { return handleClick(); }}>
      <img src={"".concat(BASEURL, "/wp-content/themes/main-theme/img/like-system/").concat(stepIndex, "_").concat(id, ".png")}/>
    </button>);
});
